import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { postajob  } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class WcAdvisory extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      exportbtndisabled:false,  
      thisExportBtnText:'Export',
      blockinstopenmodal:false,
      suggestions: [],
      institute:'',
      pickedones:[],
      pickedinstIds:[],
      salary_range_forthisjob: 15000,

      job_role_other_disabled:true,
      job_subject_teaching_other_disabled:true,
      expected_qualification_other_disabled:true,
      examcertifications_other_disabled:true,
      skillsrequired_other_disabled:true
    }

    this.cancelPop = this.cancelPop.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }
 

  componentDidMount() {

          var THIS = this;
  
   

  }


  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };


  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
  handleSubmit =(e) =>{

    let req = JSON.stringify({
        user_id:this.state.user_id,
        job_title: this.state.job_title,
        job_category: this.state.job_category,
        job_description: this.state.job_description,
        open_date: this.state.open_date,
        closing_date: this.state.closing_date,
        job_location: this.state.job_location,
        salary_range_forthisjob: this.state.salary_range_forthisjob,
        language_preferred: this.state.language_preferred,
        job_description: this.state.job_description,
        expected_qualification: this.state.expected_qualification,
        skillsrequired: this.state.skillsrequired,
        job_role: this.state.job_role,
        job_subject_teaching: this.state.job_subject_teaching,
        job_experience: this.state.job_experience,
        examcertifications: this.state.examcertifications,
        expected_qualification_other: this.state.expected_qualification_other,
        skillsrequired_other: this.state.skillsrequired_other,
        job_role_other: this.state.job_role_other,
        job_subject_teaching_other: this.state.job_subject_teaching_other,
        examcertifications_other: this.state.examcertifications_other

    })
    
    postajob(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Posted job successfully', 'Post a job');

      }else{
            
        NotificationManager.error('Error posting a job', 'Post a job');
      }

    });
}

 
  
 
  render() {
 const {value, suggestions, pickedones} = this.state;


    const formatkg = value => value;
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                    <div id="overlayadvisory"> <div id="overlayimg"><div class="heading">Coming soon</div></div></div>
                    
                    <div class="tilebox">
                    
                            <div class="adv_block">

                            <div class="wc-column c100 bgforcourse semibordered" style={{backgroundImage:`url('/images/patternbg.png')`}}>
                              <div class="course_h3title">Support services we offer</div>
                              <div class="course_desc">
                                <p>Elevate your and your institution's potential with our exclusive bespoke services, meticulously crafted to fuel the professional development of educational institutions and teachers. Our personalized offerings streamline processes, focusing on speed and efficiency to help your institution execute its vision with precision. Whether nurturing your teaching staff's talents, innovating your curriculum, or enhancing overall performance, our bespoke services are the catalyst for transformation. </p>
                                <p>Join us to redefine education and experience the profound impact of our platform on your institution's growth and educator success.</p>
                              </div>
                            </div>

                              <div class="flexby4">

                                    <div class="flexby4_item"  style={{backgroundImage:`url('/images/advisory/1.png')`}}><span>Relocation support</span></div>
                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/2.png')`}}><span>Reference Checks/ Assessment support</span></div>
                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/3.png')`}}><span>Improve Org Profile - attract talent</span></div>
                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/4.png')`}}><span>Advertising & newsletter promos</span></div>
                              </div>

                              <div class="flexby4">

                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/5.png')`}}><span>Curated Partnerships for growth</span></div>
                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/6.png')`}}><span>Outsourcing</span></div>
                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/7.png')`}}><span>Thought leadership - Write blog / article</span></div>
                                    <div class="flexby4_item" style={{backgroundImage:`url('/images/advisory/8.png')`}}><span>Leadership trainings and team building</span></div>


                              </div>

                            </div>

                    </div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default WcAdvisory;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/advisory.jsx